export default __webpack_public_path__ + "media/images/carnival/header_1280x840_sp-955552cf19ef1c4fb71c50180d419b3a.jpg";